import { ReactNode } from 'react';

import styles from './Diff.module.scss';


interface DiffIconProps {
    children: ReactNode;
}

export function DiffIcon({ children }: DiffIconProps) {
    return (
        <div className={styles.diffIcon}>
            {children}
        </div>
    );
}
